export default ({ request }) => ({
  tcFabricPurchaseListApi(data = {}) {
    return request({
      url: '/factory/tc/fabric/purchase/list',
      method: 'post',
      data,
    })
  },
  tcFabricPurchaseDetailApi(data = {}) {
    return request({
      url: '/factory/tc/fabric/purchase/detail',
      method: 'post',
      data,
    })
  },
  tcFabricPurchaseCreateDataApi(data = {}) {
    return request({
      url: '/factory/tc/fabric/purchase/createData',
      method: 'post',
      data,
    })
  },
  tcFabricPurchaseSaveApi(data = {}) {
    return request({
      url: '/factory/tc/fabric/purchase/save',
      method: 'post',
      data,
    })
  },
  tcFabricPurchaseDelApi(data = {}) {
    return request({
      url: '/factory/tc/fabric/purchase/del',
      method: 'post',
      data,
    })
  },
  tcFabricPurchaseReviewApi(data = {}) {
    return request({
      url: '/factory/tc/fabric/purchase/review',
      method: 'post',
      data,
    })
  },
  tcFabricPurchaseDetailOptionalApi(data = {}) {
    return request({
      url: '/factory/tc/fabric/purchase/detail/optional',
      method: 'post',
      data,
    })
  },
  tcFabricPurchaseExportCheckApi(data = {}) {
    return request({
      url: '/factory/tc/fabric/purchase/exportCheck',
      method: 'post',
      data,
    })
  },
})
